module.exports = __webpack_public_path__ + "static/media/18-accounting_for_ourselves.64278774.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/18-accounting_for_ourselves.pdf
// module id = 167
// module chunks = 0